import axios, { AxiosInstance } from "axios";
import { encrypt, decrypt, hybridEncrypt, importPublicKey, rsaEncrypt } from "./encryption";
import { strToArrayBuffer } from "./common";
const baseURL = process.env.REACT_APP_BASE_URL;

const createAxiosInstance = (endpoint: string = "") => {
  const newInstance = axios.create({
    baseURL:
      endpoint === "kyp"
        ? process.env.REACT_APP_KYP_BASE_URL
        : endpoint === "wc-claims"
          ? process.env.REACT_APP_WC_CLAIMS_BASE_URL
          : endpoint === "tech-eo"
            ? process.env.REACT_APP_Tech_EO_BASE_URL
            : endpoint === "tech-do"
              ? process.env.REACT_APP_Tech_DO_BASE_URL
              : endpoint === "apigee"
                ? process.env.REACT_APP_APIGEE
                : endpoint === "dtr"
                  ? process.env.REACT_APP_DTR_BASE_URL
                  : `${baseURL}/${endpoint}`,
  });

  newInstance.interceptors.request.use(async function (request) {
    const userDetails = localStorage.getItem("userDetails")!;
    const key = localStorage.getItem("publicKey");
    if (userDetails) {
      const { method, data } = request;
      if (method === "post" && !data) request.data = {};
      // let token = JSON.parse(decrypt(userDetails || ""))?.accessToken;
      let token = JSON.parse(userDetails)?.accessToken;
      request.headers.Authorization = `Bearer ${token}`;
      if (request.data?.encryption && key) {
        // request.data.user = JSON.parse(userDetails);
        const formattedRequestData = await hybridEncrypt(
          JSON.stringify(request.data?.data ? { ...request.data.data } : { ...request.data }),
          key
        );
        const formattedUser = await hybridEncrypt(userDetails, key);
        request.data = { data: formattedRequestData?.data, user: formattedUser?.data };
      } else if (method !== "get" && key) {
        const formattedUser = await hybridEncrypt(userDetails, key);
        request.data.user = formattedUser?.data;
      }
    }
    return request;
  });

  newInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (
        error.response &&
        error.response.status === 401 &&
        window.location.pathname !== "/login"
      ) {
        // Access Token was expired
        localStorage.removeItem("userDetails");
        localStorage.removeItem("publicKey");
        // localStorage.removeItem("apigeeToken");
        window.location.pathname = "/login";
      }
      return Promise.reject(error);
    },
  );

  return newInstance;
};

const hrClient = createAxiosInstance("hr-bot/v2");

const documentClient = createAxiosInstance("doc-analyzer/v2");

const competitorClient = createAxiosInstance("competative-analysis");

const productClient = createAxiosInstance("product-catalogue/v3");

const legalClient = createAxiosInstance("legal");

const qcClient = createAxiosInstance("qc");

const kypClient = createAxiosInstance("kyp");

const wcClaimsClient = createAxiosInstance("wc-claims");
const techEOClient = createAxiosInstance("tech-eo");
const techDOClient = createAxiosInstance("tech-do");
const apigeeClient = createAxiosInstance("apigee");
const dtrClient = createAxiosInstance("dtr");

const baseClient = createAxiosInstance();

export const tools: Record<string, AxiosInstance> = {
  hr: hrClient,
  competitor: competitorClient,
  catalog: productClient,
  document: documentClient,
  help: documentClient,
  legal: legalClient,
  qc: qcClient,
  kyp: kypClient,
  "wc-claims": wcClaimsClient,
  "tech-eo": techEOClient,
  "tech-do": techDOClient,
  apigee: apigeeClient,
  dtr: dtrClient,
  default: baseClient,
};

export const getClient = (tool: string = "default") => {
  return tools[tool];
};

export const sendOTP = () => {
  const { data }: any = axios.post("https://otp-service.hdfcergo.com/sms/otp", {
    length: 4,
    templateName: "OTP_HDFC_ERGO",
    projectName: "CHASE",
    mobile: "7738184161",
  });
  return data;
};
export const verifyOTP = (payload: any) => {
  const { data }: any = axios.post(
    "https://otp-service.hdfcergo.com//sms/verifyOtp",
    {
      otp: payload,
      mobile: "7738184161",
      duration: 3,
    },
  );
  return data;
};
